import { styled } from '@mui/material/styles';
import { Typography, Box, Grid, Button, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";

import FileUploadIcon from '@mui/icons-material/FileUpload';
import DownloadIcon from '@mui/icons-material/Download';

import axios from 'axios';
import { useAppContext } from "../../../libs/contextlib";
import { useState } from 'react';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});



export default function BulkLoadByEconomicGroup() {

    const { hostService,
        setAlertMessageOpen,
        setAlertMessageTitle,
        setAlertMessageDescription,
        setAlertMessageType, 
        downloadBase64,
        setDownloadingTitle,
        setDownloadingOpen} = useAppContext();

    const [errorsObj, setErrorsObj] = useState({});

    function handleFileChange(event) {
        const file = event.target.files[0];
        if (file) {
            uploadExcel(file);
        }
    }

    async function downloadExcelTemplate() {
        setDownloadingTitle('Descargando Excel');
        setDownloadingOpen(true);

        try {
            axios({
                method: "post",
                url: hostService + 'servicios/Compradores.asmx/DownloadAmountAndRateFileByEG',
                data: {},
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
                responseType: 'text'
            })
                .then(response => {
                    setDownloadingOpen(false);

                    let respuesta = JSON.parse(response.data.d);

                    if (respuesta.status === 'ok') {
                        downloadBase64('Pantilla grupos económicos.xlsx', respuesta.data.data);
                    }
                    else if (respuesta.status === 'error') {
                        setAlertMessageOpen(true);
                        setAlertMessageTitle(respuesta.data.userMsg);
                        setAlertMessageDescription('');
                        setAlertMessageType('warning');
                    }
                })
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async function uploadExcel(excel) {
        const formData = new FormData();
        formData.append('file', excel);

        try {
            axios({
                method: "post",
                url: hostService + 'servicios/Compradores.asmx/UpdateAmountAndRateMassivelyByEG',
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true,
                responseType: 'text'
            }).then(response => {
                const xmlString = response.data;
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
                const jsonString = xmlDoc.getElementsByTagName('string')[0].textContent;
                const jsonResponse = JSON.parse(jsonString);

                if(jsonResponse.status === 'ok'){
                    let property = Object.keys(jsonResponse.data.data);

                    if (property.length > 0) {
                        setErrorsObj(jsonResponse.data.data);
                    } else {
                        setAlertMessageOpen(true);
                        setAlertMessageTitle("Operación completada");
                        setAlertMessageDescription("Se actualizaron los montos exitosamente.");
                        setAlertMessageType('success');
                    }

                }else{
                    setAlertMessageOpen(true);
                    setAlertMessageTitle(jsonResponse.data.userMsg);
                    setAlertMessageDescription('');
                    setAlertMessageType('error');
                }
            })
        } catch (error) {
            console.error('Error:', error);
        }
    }

    return (
        <Grid item xs={6} sx={{
            height: "85vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <Box>
                <Typography
                    fontWeight={600}
                    align="left"
                    variant="h4"
                    sx={{ padding: "1rem 0" }}>
                    Carga Masiva por grupo económico
                </Typography>
                <Typography
                    align="center"
                    variant="body">
                    Carga de manera masiva los montos totales para cada grupo económico mediante un archivo excel.
                </Typography>
                <Box sx={{ display: "flex", gap: "1rem", justifyContent: "center", padding: "2rem 0" }}>
                        <Button component="label" variant="outlined" startIcon={<DownloadIcon />} onClick={downloadExcelTemplate}>
                            Descargar Plantilla
                        </Button>
                    <Button
                        component="label"
                        variant="contained"
                        color="buttonColor"
                        startIcon={<FileUploadIcon />}
                    >
                        Subir Excel
                        <VisuallyHiddenInput type="file" onChange={handleFileChange} />
                    </Button>
                </Box>
            </Box>
            {
                Object.entries(errorsObj).length > 0 && <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Rut de la pagadora</TableCell>
                                <TableCell align="center">Errores</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {Object.entries(errorsObj).map(([grupo, error]) => (
                        <TableRow
                            key={grupo}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell align="center" component="th" scope="row">
                                {grupo}
                            </TableCell>
                            <TableCell align="center">{error}</TableCell>
                        </TableRow>
                    ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </Grid >
    )
}